import React, { Fragment, useState } from 'react';
import { identity, prop } from 'ramda';
import { componentService } from 'js/services/component.service';
import { usePortletConfig, usePortletSelector, withPortlet } from 'js/components/system/Portlet';
import reducer, { initialState } from './reducer';
import { useTranslations } from 'js/hooks/i18n';
import { NEVIS_PASSKEYS_SWISS } from './constants';
import { fetchNevisPasskeys } from './actions';
import { useDeviceSelector } from 'js/store/hooks';
import { useCreatePasskey } from '@theme/js/components/main/NevisPasskeysSwiss/hooks/useCreatePasskey';
import { NevisPasskeysDesktop } from './components/NevisPasskeysNoItem/NevisPasskeysDesktop';
import { NevisPasskeysItems } from './components/NevisPasskeysItems/NevisPasskeysItems';
import { NevisPasskeysMobile } from './components/NevisPasskeysNoItem/NevisPasskeysMobile';
import {
    INevisPasskeysSwissComponentsProps,
    INevisPasskeysResponse,
    NevisPasskeysSwissPropsTypes
} from '@theme/js/components/main/NevisPasskeysSwiss/types';
import { TPortletInfo } from '@core/js/components/hocs/withComponent/types';

export const NevisPasskeysSwissBare: React.FC<INevisPasskeysSwissComponentsProps> = ({ fetchPortlet }) => {
    const { tkPrefix, portletType } = usePortletConfig() as TPortletInfo;
    const t = useTranslations();
    const isMobile = useDeviceSelector(prop('isMobile'));
    const [isDisabled, setDisabledState] = useState<boolean>(false);
    const data = usePortletSelector(prop('data')<INevisPasskeysResponse>) ?? {};

    const createPassKey = useCreatePasskey({
        setDisabledState,
        data,
        fetchPortlet,
        portletType,
        tkPrefix
    });

    return <Fragment>
        {isMobile && !data?.fidoAuthenticators?.length &&
            <NevisPasskeysMobile
                tkPrefix={tkPrefix}
                isDisabled={isDisabled}
                createPassKey={createPassKey}
                t={t}
            />
        }

        {!isMobile &&
            <NevisPasskeysDesktop
                tkPrefix={tkPrefix}
                isDisabled={isDisabled}
                createPassKey={createPassKey}
                t={t}
            />
        }

        {Boolean(data?.fidoAuthenticators?.length) &&
            <NevisPasskeysItems
                tkPrefix={tkPrefix}
                isDisabled={isDisabled}
                t={t}
                data={data}
                isMobile={isMobile}
                createPassKey={createPassKey}
                fetchPortlet={fetchPortlet}
                portletType={portletType}
            />
        }
    </Fragment>;
};

const typedWithPortlet = (args: NevisPasskeysSwissPropsTypes) => {
    return (withPortlet as (props: NevisPasskeysSwissPropsTypes) =>
        ((component: React.FC<INevisPasskeysSwissComponentsProps>) => React.FC))(args);
};

export const NevisPasskeysSwiss = (typedWithPortlet({
    forLoggedIn: true,
    fetch: fetchNevisPasskeys,
    onResponse: identity,
    reducer,
    initialState
}) as ((component: React.FC<INevisPasskeysSwissComponentsProps>) => React.FC)) (NevisPasskeysSwissBare);
componentService.registerPageComponents({ [NEVIS_PASSKEYS_SWISS]: NevisPasskeysSwiss });
